export default function CursorSVG() {
  return (
    <div class="h-[16px] w-[6px] bg-black block cursor ml-1 align-middle"></div>
  );
}
